/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CenterTeacherDto } from '../models/center-teacher-dto';
import { CenterUserAccountingDto } from '../models/center-user-accounting-dto';
import { centerUserControllerAddColor } from '../fn/center-user/center-user-controller-add-color';
import { CenterUserControllerAddColor$Params } from '../fn/center-user/center-user-controller-add-color';
import { centerUserControllerDelegate } from '../fn/center-user/center-user-controller-delegate';
import { CenterUserControllerDelegate$Params } from '../fn/center-user/center-user-controller-delegate';
import { centerUserControllerDeleteColor } from '../fn/center-user/center-user-controller-delete-color';
import { CenterUserControllerDeleteColor$Params } from '../fn/center-user/center-user-controller-delete-color';
import { centerUserControllerDeleteUser } from '../fn/center-user/center-user-controller-delete-user';
import { CenterUserControllerDeleteUser$Params } from '../fn/center-user/center-user-controller-delete-user';
import { centerUserControllerDeleteUserByAdmin } from '../fn/center-user/center-user-controller-delete-user-by-admin';
import { CenterUserControllerDeleteUserByAdmin$Params } from '../fn/center-user/center-user-controller-delete-user-by-admin';
import { centerUserControllerExit } from '../fn/center-user/center-user-controller-exit';
import { CenterUserControllerExit$Params } from '../fn/center-user/center-user-controller-exit';
import { centerUserControllerFindAllOwners } from '../fn/center-user/center-user-controller-find-all-owners';
import { CenterUserControllerFindAllOwners$Params } from '../fn/center-user/center-user-controller-find-all-owners';
import { centerUserControllerFindByChildId } from '../fn/center-user/center-user-controller-find-by-child-id';
import { CenterUserControllerFindByChildId$Params } from '../fn/center-user/center-user-controller-find-by-child-id';
import { centerUserControllerFindById } from '../fn/center-user/center-user-controller-find-by-id';
import { CenterUserControllerFindById$Params } from '../fn/center-user/center-user-controller-find-by-id';
import { centerUserControllerFindByUserIdAndCenterId } from '../fn/center-user/center-user-controller-find-by-user-id-and-center-id';
import { CenterUserControllerFindByUserIdAndCenterId$Params } from '../fn/center-user/center-user-controller-find-by-user-id-and-center-id';
import { centerUserControllerFindUserById } from '../fn/center-user/center-user-controller-find-user-by-id';
import { CenterUserControllerFindUserById$Params } from '../fn/center-user/center-user-controller-find-user-by-id';
import { centerUserControllerFindUsersByCenterId } from '../fn/center-user/center-user-controller-find-users-by-center-id';
import { CenterUserControllerFindUsersByCenterId$Params } from '../fn/center-user/center-user-controller-find-users-by-center-id';
import { centerUserControllerGetAccounting } from '../fn/center-user/center-user-controller-get-accounting';
import { CenterUserControllerGetAccounting$Params } from '../fn/center-user/center-user-controller-get-accounting';
import { centerUserControllerGetChildren } from '../fn/center-user/center-user-controller-get-children';
import { CenterUserControllerGetChildren$Params } from '../fn/center-user/center-user-controller-get-children';
import { centerUserControllerGetStat } from '../fn/center-user/center-user-controller-get-stat';
import { CenterUserControllerGetStat$Params } from '../fn/center-user/center-user-controller-get-stat';
import { centerUserControllerGetStatBulk } from '../fn/center-user/center-user-controller-get-stat-bulk';
import { CenterUserControllerGetStatBulk$Params } from '../fn/center-user/center-user-controller-get-stat-bulk';
import { centerUserControllerGetTeachers } from '../fn/center-user/center-user-controller-get-teachers';
import { CenterUserControllerGetTeachers$Params } from '../fn/center-user/center-user-controller-get-teachers';
import { centerUserControllerInvisibleInfo } from '../fn/center-user/center-user-controller-invisible-info';
import { CenterUserControllerInvisibleInfo$Params } from '../fn/center-user/center-user-controller-invisible-info';
import { centerUserControllerSearch } from '../fn/center-user/center-user-controller-search';
import { CenterUserControllerSearch$Params } from '../fn/center-user/center-user-controller-search';
import { centerUserControllerSetColor } from '../fn/center-user/center-user-controller-set-color';
import { CenterUserControllerSetColor$Params } from '../fn/center-user/center-user-controller-set-color';
import { centerUserControllerTriggerCronJob } from '../fn/center-user/center-user-controller-trigger-cron-job';
import { CenterUserControllerTriggerCronJob$Params } from '../fn/center-user/center-user-controller-trigger-cron-job';
import { centerUserControllerUpdateHrInfo } from '../fn/center-user/center-user-controller-update-hr-info';
import { CenterUserControllerUpdateHrInfo$Params } from '../fn/center-user/center-user-controller-update-hr-info';
import { centerUserControllerUpdateHrInfoMultiple } from '../fn/center-user/center-user-controller-update-hr-info-multiple';
import { CenterUserControllerUpdateHrInfoMultiple$Params } from '../fn/center-user/center-user-controller-update-hr-info-multiple';
import { centerUserControllerUpdateMemo } from '../fn/center-user/center-user-controller-update-memo';
import { CenterUserControllerUpdateMemo$Params } from '../fn/center-user/center-user-controller-update-memo';
import { centerUserControllerUpdateUser } from '../fn/center-user/center-user-controller-update-user';
import { CenterUserControllerUpdateUser$Params } from '../fn/center-user/center-user-controller-update-user';
import { CenterUserDto } from '../models/center-user-dto';
import { CenterUserStatBulkItemDto } from '../models/center-user-stat-bulk-item-dto';
import { CenterUserStatDto } from '../models/center-user-stat-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { UserDto } from '../models/user-dto';

@Injectable({ providedIn: 'root' })
export class CenterUserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `centerUserControllerTriggerCronJob()` */
  static readonly CenterUserControllerTriggerCronJobPath = '/api/center-user/cron';

  /**
   * 급여 크론 잡 트리거 (개발용).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerTriggerCronJob()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerTriggerCronJob$Response(params?: CenterUserControllerTriggerCronJob$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return centerUserControllerTriggerCronJob(this.http, this.rootUrl, params, context);
  }

  /**
   * 급여 크론 잡 트리거 (개발용).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerTriggerCronJob$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerTriggerCronJob(params?: CenterUserControllerTriggerCronJob$Params, context?: HttpContext): Observable<void> {
    return this.centerUserControllerTriggerCronJob$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `centerUserControllerFindAllOwners()` */
  static readonly CenterUserControllerFindAllOwnersPath = '/api/center-user/users/owner';

  /**
   * 대표 관리자 조회.
   *
   * 대표 관리자 목록을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerFindAllOwners()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerFindAllOwners$Response(params?: CenterUserControllerFindAllOwners$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserDto>>> {
    return centerUserControllerFindAllOwners(this.http, this.rootUrl, params, context);
  }

  /**
   * 대표 관리자 조회.
   *
   * 대표 관리자 목록을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerFindAllOwners$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerFindAllOwners(params?: CenterUserControllerFindAllOwners$Params, context?: HttpContext): Observable<Array<UserDto>> {
    return this.centerUserControllerFindAllOwners$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserDto>>): Array<UserDto> => r.body)
    );
  }

  /** Path part for operation `centerUserControllerGetTeachers()` */
  static readonly CenterUserControllerGetTeachersPath = '/api/center-user/teachers';

  /**
   * 센터에 속한 선생님 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerGetTeachers()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerGetTeachers$Response(params: CenterUserControllerGetTeachers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterTeacherDto>>> {
    return centerUserControllerGetTeachers(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터에 속한 선생님 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerGetTeachers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerGetTeachers(params: CenterUserControllerGetTeachers$Params, context?: HttpContext): Observable<Array<CenterTeacherDto>> {
    return this.centerUserControllerGetTeachers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CenterTeacherDto>>): Array<CenterTeacherDto> => r.body)
    );
  }

  /** Path part for operation `centerUserControllerFindByChildId()` */
  static readonly CenterUserControllerFindByChildIdPath = '/api/center-user/child';

  /**
   * 아동의 선생님 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerFindByChildId()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerFindByChildId$Response(params: CenterUserControllerFindByChildId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterUserDto>>> {
    return centerUserControllerFindByChildId(this.http, this.rootUrl, params, context);
  }

  /**
   * 아동의 선생님 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerFindByChildId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerFindByChildId(params: CenterUserControllerFindByChildId$Params, context?: HttpContext): Observable<Array<CenterUserDto>> {
    return this.centerUserControllerFindByChildId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CenterUserDto>>): Array<CenterUserDto> => r.body)
    );
  }

  /** Path part for operation `centerUserControllerGetChildren()` */
  static readonly CenterUserControllerGetChildrenPath = '/api/center-user/children';

  /**
   * 내가 속한 센터의 아동 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerGetChildren()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerGetChildren$Response(params: CenterUserControllerGetChildren$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterTeacherDto>>> {
    return centerUserControllerGetChildren(this.http, this.rootUrl, params, context);
  }

  /**
   * 내가 속한 센터의 아동 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerGetChildren$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerGetChildren(params: CenterUserControllerGetChildren$Params, context?: HttpContext): Observable<Array<CenterTeacherDto>> {
    return this.centerUserControllerGetChildren$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CenterTeacherDto>>): Array<CenterTeacherDto> => r.body)
    );
  }

  /** Path part for operation `centerUserControllerGetStat()` */
  static readonly CenterUserControllerGetStatPath = '/api/center-user/stat';

  /**
   * 센터 구성원 통계 조회.
   *
   * 센터 구성원의 통계를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerGetStat()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerGetStat$Response(params: CenterUserControllerGetStat$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserStatDto>> {
    return centerUserControllerGetStat(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 구성원 통계 조회.
   *
   * 센터 구성원의 통계를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerGetStat$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerGetStat(params: CenterUserControllerGetStat$Params, context?: HttpContext): Observable<CenterUserStatDto> {
    return this.centerUserControllerGetStat$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterUserStatDto>): CenterUserStatDto => r.body)
    );
  }

  /** Path part for operation `centerUserControllerGetStatBulk()` */
  static readonly CenterUserControllerGetStatBulkPath = '/api/center-user/stat/bulk';

  /**
   * 센터 구성원 통계 일괄 조회.
   *
   * 여러 센터 구성원의 통계를 한 번에 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerGetStatBulk()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerGetStatBulk$Response(params: CenterUserControllerGetStatBulk$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterUserStatBulkItemDto>>> {
    return centerUserControllerGetStatBulk(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 구성원 통계 일괄 조회.
   *
   * 여러 센터 구성원의 통계를 한 번에 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerGetStatBulk$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerGetStatBulk(params: CenterUserControllerGetStatBulk$Params, context?: HttpContext): Observable<Array<CenterUserStatBulkItemDto>> {
    return this.centerUserControllerGetStatBulk$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CenterUserStatBulkItemDto>>): Array<CenterUserStatBulkItemDto> => r.body)
    );
  }

  /** Path part for operation `centerUserControllerGetAccounting()` */
  static readonly CenterUserControllerGetAccountingPath = '/api/center-user/accounting';

  /**
   * 센터 구성원 회계 정보 조회.
   *
   * 센터 구성원의 회계 정보를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerGetAccounting()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerGetAccounting$Response(params: CenterUserControllerGetAccounting$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserAccountingDto>> {
    return centerUserControllerGetAccounting(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 구성원 회계 정보 조회.
   *
   * 센터 구성원의 회계 정보를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerGetAccounting$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerGetAccounting(params: CenterUserControllerGetAccounting$Params, context?: HttpContext): Observable<CenterUserAccountingDto> {
    return this.centerUserControllerGetAccounting$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterUserAccountingDto>): CenterUserAccountingDto => r.body)
    );
  }

  /** Path part for operation `centerUserControllerFindById()` */
  static readonly CenterUserControllerFindByIdPath = '/api/center-user/{id}';

  /**
   * 센터 구성원 ID 기반 조회.
   *
   * 센터 구성원을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerFindById$Response(params: CenterUserControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserDto>> {
    return centerUserControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 구성원 ID 기반 조회.
   *
   * 센터 구성원을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerFindById(params: CenterUserControllerFindById$Params, context?: HttpContext): Observable<CenterUserDto> {
    return this.centerUserControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterUserDto>): CenterUserDto => r.body)
    );
  }

  /** Path part for operation `centerUserControllerFindUsersByCenterId()` */
  static readonly CenterUserControllerFindUsersByCenterIdPath = '/api/center-user/{centerId}/users';

  /**
   * 센터 ID 기반 구성원 목록 조회.
   *
   * 센터 ID를 기반으로 구성원 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerFindUsersByCenterId()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerFindUsersByCenterId$Response(params: CenterUserControllerFindUsersByCenterId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterUserDto>>> {
    return centerUserControllerFindUsersByCenterId(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 ID 기반 구성원 목록 조회.
   *
   * 센터 ID를 기반으로 구성원 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerFindUsersByCenterId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerFindUsersByCenterId(params: CenterUserControllerFindUsersByCenterId$Params, context?: HttpContext): Observable<Array<CenterUserDto>> {
    return this.centerUserControllerFindUsersByCenterId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CenterUserDto>>): Array<CenterUserDto> => r.body)
    );
  }

  /** Path part for operation `centerUserControllerSearch()` */
  static readonly CenterUserControllerSearchPath = '/api/center-user/{centerId}/users/search';

  /**
   * 센터 ID 기반 구성원 검색.
   *
   * 센터 ID를 기반으로 구성원 전체를 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerSearch$Response(params: CenterUserControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return centerUserControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 ID 기반 구성원 검색.
   *
   * 센터 ID를 기반으로 구성원 전체를 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerSearch(params: CenterUserControllerSearch$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.centerUserControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `centerUserControllerFindByUserIdAndCenterId()` */
  static readonly CenterUserControllerFindByUserIdAndCenterIdPath = '/api/center-user/{centerId}/users/user-center';

  /**
   * 구성원 찾기.
   *
   * 사용자 ID와 센터 ID를 기반으로 구성원을 찾습니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerFindByUserIdAndCenterId()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerFindByUserIdAndCenterId$Response(params: CenterUserControllerFindByUserIdAndCenterId$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserDto>> {
    return centerUserControllerFindByUserIdAndCenterId(this.http, this.rootUrl, params, context);
  }

  /**
   * 구성원 찾기.
   *
   * 사용자 ID와 센터 ID를 기반으로 구성원을 찾습니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerFindByUserIdAndCenterId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerFindByUserIdAndCenterId(params: CenterUserControllerFindByUserIdAndCenterId$Params, context?: HttpContext): Observable<CenterUserDto> {
    return this.centerUserControllerFindByUserIdAndCenterId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterUserDto>): CenterUserDto => r.body)
    );
  }

  /** Path part for operation `centerUserControllerFindUserById()` */
  static readonly CenterUserControllerFindUserByIdPath = '/api/center-user/{centerId}/users/{centerUserId}';

  /**
   * 센터 구성원 ID 기반 조회.
   *
   * 센터 구성원을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerFindUserById()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerFindUserById$Response(params: CenterUserControllerFindUserById$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserDto>> {
    return centerUserControllerFindUserById(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 구성원 ID 기반 조회.
   *
   * 센터 구성원을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerFindUserById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerFindUserById(params: CenterUserControllerFindUserById$Params, context?: HttpContext): Observable<CenterUserDto> {
    return this.centerUserControllerFindUserById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterUserDto>): CenterUserDto => r.body)
    );
  }

  /** Path part for operation `centerUserControllerDeleteUser()` */
  static readonly CenterUserControllerDeleteUserPath = '/api/center-user/{centerId}/users/{centerUserId}';

  /**
   * 센터 구성원 추방.
   *
   * 센터 구성원을 추방합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerDeleteUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerDeleteUser$Response(params: CenterUserControllerDeleteUser$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserDto>> {
    return centerUserControllerDeleteUser(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 구성원 추방.
   *
   * 센터 구성원을 추방합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerDeleteUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerDeleteUser(params: CenterUserControllerDeleteUser$Params, context?: HttpContext): Observable<CenterUserDto> {
    return this.centerUserControllerDeleteUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterUserDto>): CenterUserDto => r.body)
    );
  }

  /** Path part for operation `centerUserControllerUpdateUser()` */
  static readonly CenterUserControllerUpdateUserPath = '/api/center-user/{centerId}/users/{centerUserId}';

  /**
   * 센터 구성원 역할 변경.
   *
   * 센터 구성원의 역할을 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerUpdateUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerUserControllerUpdateUser$Response(params: CenterUserControllerUpdateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserDto>> {
    return centerUserControllerUpdateUser(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 구성원 역할 변경.
   *
   * 센터 구성원의 역할을 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerUpdateUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerUserControllerUpdateUser(params: CenterUserControllerUpdateUser$Params, context?: HttpContext): Observable<CenterUserDto> {
    return this.centerUserControllerUpdateUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterUserDto>): CenterUserDto => r.body)
    );
  }

  /** Path part for operation `centerUserControllerUpdateHrInfoMultiple()` */
  static readonly CenterUserControllerUpdateHrInfoMultiplePath = '/api/center-user/{centerId}/users/hr-info/multiple';

  /**
   * 센터 구성원 인사 정보 변경.
   *
   * 센터 구성원의 인사 정보를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerUpdateHrInfoMultiple()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerUserControllerUpdateHrInfoMultiple$Response(params: CenterUserControllerUpdateHrInfoMultiple$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserDto>> {
    return centerUserControllerUpdateHrInfoMultiple(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 구성원 인사 정보 변경.
   *
   * 센터 구성원의 인사 정보를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerUpdateHrInfoMultiple$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerUserControllerUpdateHrInfoMultiple(params: CenterUserControllerUpdateHrInfoMultiple$Params, context?: HttpContext): Observable<CenterUserDto> {
    return this.centerUserControllerUpdateHrInfoMultiple$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterUserDto>): CenterUserDto => r.body)
    );
  }

  /** Path part for operation `centerUserControllerDeleteColor()` */
  static readonly CenterUserControllerDeleteColorPath = '/api/center-user/{centerId}/users/{centerUserId}/colors';

  /**
   * 센터 색상 삭제.
   *
   * 센터에서 사용할 색상을 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerDeleteColor()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerDeleteColor$Response(params: CenterUserControllerDeleteColor$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return centerUserControllerDeleteColor(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 색상 삭제.
   *
   * 센터에서 사용할 색상을 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerDeleteColor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerDeleteColor(params: CenterUserControllerDeleteColor$Params, context?: HttpContext): Observable<boolean> {
    return this.centerUserControllerDeleteColor$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `centerUserControllerAddColor()` */
  static readonly CenterUserControllerAddColorPath = '/api/center-user/{centerId}/users/{centerUserId}/colors';

  /**
   * 센터 색상 추가.
   *
   * 센터에서 사용할 색상을 추가합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerAddColor()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerAddColor$Response(params: CenterUserControllerAddColor$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return centerUserControllerAddColor(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 색상 추가.
   *
   * 센터에서 사용할 색상을 추가합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerAddColor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerAddColor(params: CenterUserControllerAddColor$Params, context?: HttpContext): Observable<boolean> {
    return this.centerUserControllerAddColor$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `centerUserControllerSetColor()` */
  static readonly CenterUserControllerSetColorPath = '/api/center-user/{centerId}/users/{centerUserId}/color';

  /**
   * 센터 색상 변경.
   *
   * 센터의 색상을 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerSetColor()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerSetColor$Response(params: CenterUserControllerSetColor$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return centerUserControllerSetColor(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 색상 변경.
   *
   * 센터의 색상을 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerSetColor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerSetColor(params: CenterUserControllerSetColor$Params, context?: HttpContext): Observable<boolean> {
    return this.centerUserControllerSetColor$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `centerUserControllerUpdateHrInfo()` */
  static readonly CenterUserControllerUpdateHrInfoPath = '/api/center-user/{centerId}/users/{centerUserId}/hr-info';

  /**
   * 센터 구성원 인사 정보 변경.
   *
   * 센터 구성원의 인사 정보를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerUpdateHrInfo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerUserControllerUpdateHrInfo$Response(params: CenterUserControllerUpdateHrInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserDto>> {
    return centerUserControllerUpdateHrInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 구성원 인사 정보 변경.
   *
   * 센터 구성원의 인사 정보를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerUpdateHrInfo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerUserControllerUpdateHrInfo(params: CenterUserControllerUpdateHrInfo$Params, context?: HttpContext): Observable<CenterUserDto> {
    return this.centerUserControllerUpdateHrInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterUserDto>): CenterUserDto => r.body)
    );
  }

  /** Path part for operation `centerUserControllerUpdateMemo()` */
  static readonly CenterUserControllerUpdateMemoPath = '/api/center-user/{centerId}/users/{centerUserId}/memo';

  /**
   * 센터 구성원 인사 정보 변경.
   *
   * 센터 구성원의 인사 정보를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerUpdateMemo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerUserControllerUpdateMemo$Response(params: CenterUserControllerUpdateMemo$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserDto>> {
    return centerUserControllerUpdateMemo(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 구성원 인사 정보 변경.
   *
   * 센터 구성원의 인사 정보를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerUpdateMemo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  centerUserControllerUpdateMemo(params: CenterUserControllerUpdateMemo$Params, context?: HttpContext): Observable<CenterUserDto> {
    return this.centerUserControllerUpdateMemo$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterUserDto>): CenterUserDto => r.body)
    );
  }

  /** Path part for operation `centerUserControllerDelegate()` */
  static readonly CenterUserControllerDelegatePath = '/api/center-user/{centerId}/users/{centerUserId}/delegate';

  /**
   * 센터 대표 위임.
   *
   * 센터 대표를 위임합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerDelegate()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerDelegate$Response(params: CenterUserControllerDelegate$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserDto>> {
    return centerUserControllerDelegate(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 대표 위임.
   *
   * 센터 대표를 위임합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerDelegate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerDelegate(params: CenterUserControllerDelegate$Params, context?: HttpContext): Observable<CenterUserDto> {
    return this.centerUserControllerDelegate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterUserDto>): CenterUserDto => r.body)
    );
  }

  /** Path part for operation `centerUserControllerInvisibleInfo()` */
  static readonly CenterUserControllerInvisibleInfoPath = '/api/center-user/{centerId}/users/{centerUserId}/invisible';

  /**
   * 센터 구성원 정보 숨기기.
   *
   * 센터 구성원의 정보를 숨김 처리 합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerInvisibleInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerInvisibleInfo$Response(params: CenterUserControllerInvisibleInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserDto>> {
    return centerUserControllerInvisibleInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 구성원 정보 숨기기.
   *
   * 센터 구성원의 정보를 숨김 처리 합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerInvisibleInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerInvisibleInfo(params: CenterUserControllerInvisibleInfo$Params, context?: HttpContext): Observable<CenterUserDto> {
    return this.centerUserControllerInvisibleInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterUserDto>): CenterUserDto => r.body)
    );
  }

  /** Path part for operation `centerUserControllerExit()` */
  static readonly CenterUserControllerExitPath = '/api/center-user/{centerId}/exit/{userId}';

  /**
   * 센터 탈퇴.
   *
   * 센터에서 탈퇴합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerExit()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerExit$Response(params: CenterUserControllerExit$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return centerUserControllerExit(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 탈퇴.
   *
   * 센터에서 탈퇴합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerExit$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerExit(params: CenterUserControllerExit$Params, context?: HttpContext): Observable<boolean> {
    return this.centerUserControllerExit$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `centerUserControllerDeleteUserByAdmin()` */
  static readonly CenterUserControllerDeleteUserByAdminPath = '/api/center-user/{centerId}/users/{centerUserId}/admin';

  /**
   * (관리자) 센터 구성원 삭제.
   *
   * 센터 구성원을 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerUserControllerDeleteUserByAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerDeleteUserByAdmin$Response(params: CenterUserControllerDeleteUserByAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserDto>> {
    return centerUserControllerDeleteUserByAdmin(this.http, this.rootUrl, params, context);
  }

  /**
   * (관리자) 센터 구성원 삭제.
   *
   * 센터 구성원을 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerUserControllerDeleteUserByAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerUserControllerDeleteUserByAdmin(params: CenterUserControllerDeleteUserByAdmin$Params, context?: HttpContext): Observable<CenterUserDto> {
    return this.centerUserControllerDeleteUserByAdmin$Response(params, context).pipe(
      map((r: StrictHttpResponse<CenterUserDto>): CenterUserDto => r.body)
    );
  }

}
